const epicFilterReplacements = {
  enable_epic_occasions_facet_injection: {
    epicFilter: "epicUseCaseEvents",
    dorothyFilter: "occasions",
  },
  enable_epic_style_facet_injection: {
    epicFilter: "epicStylePersonas",
  },
  enable_epic_maternity_facet_injection: {
    epicFilter: "epicMaternity",
    dorothyFilter: "maternity",
  },
  enable_epic_color_facet_injection: {
    epicFilter: "colors",
    dorothyFilter: "colors",
  },
  enable_epic_embellishment_facet_injection: {
    epicFilter: "epicEmbellishments",
    dorothyFilter: "embellishments",
  },
  enable_epic_weather_facet_injection: {
    epicFilter: "epicSeasonality",
    dorothyFilter: "season",
  },
  enable_epic_print_facet_injection: {
    epicFilter: "epicPrint",
    dorothyFilter: "print",
  },
  enable_epic_formality_facet_injection: {
    epicFilter: "epicFormality",
    dorothyFilter: "formality",
  },
  enable_epic_sleeve_facet_injection: {
    epicFilter: "epicSleeve",
    dorothyFilter: "sleeve",
  },
  enable_epic_length_facet_injection: {
    epicFilter: "epicLength",
    dorothyFilter: "length",
  },
  enable_epic_neckline_facet_injection: {
    epicFilter: "epicNeckline",
    dorothyFilter: "neckline",
  },
};
export default epicFilterReplacements;
